import React from 'react';
import PieChart from './pie-chart';

const DonutChart = (props) => <PieChart {...props} donutWidth={8} />;

export default DonutChart;
